// Recover from stale-deploy chunk errors: after a redeploy, a tab that cached the
// old index.html references old hashed chunks that no longer exist. The SPA
// fallback then returns index.html (text/html) for the missing chunk, so a dynamic
// import() fails with "Failed to fetch dynamically imported module". Reloading once
// fetches the fresh index.html + current chunks.

const KEY = "tg.lastChunkReload";

export function reloadForStaleChunk(): void {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    // at most one reload per 20s, so a genuine network failure can't loop forever
    if (Date.now() - last < 20_000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sessionStorage unavailable — still attempt a reload */
  }
  location.reload();
}

function isChunkLoadError(reason: unknown): boolean {
  const msg = String((reason as { message?: string })?.message ?? reason ?? "");
  return /dynamically imported module|Importing a module script failed|error loading dynamically/i.test(
    msg,
  );
}

export function installChunkReload(): void {
  // Vite fires this when a preload/dynamic import fails.
  window.addEventListener("vite:preloadError", (e) => {
    e.preventDefault();
    reloadForStaleChunk();
  });
  // Belt and suspenders: catch unhandled chunk-load rejections too.
  window.addEventListener("unhandledrejection", (e) => {
    if (isChunkLoadError(e.reason)) {
      e.preventDefault();
      reloadForStaleChunk();
    }
  });
}
